import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

import { ENVIRONMENT } from '@app/constants/environment.token';
import { UtilsService } from '@app/services/utils.service';

/**
 * Functional guard that allows access only in PWA standalone mode or local mode.
 * In all other cases, redirects the user to the corresponding WordPress URL
 * defined in `route.data.wpPath`.
 */
export const standaloneModeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const utilsService = inject(UtilsService);
    const env = inject(ENVIRONMENT);

    if (utilsService.isInStandaloneMode() || utilsService.isInLocalMode()) {
        return true;
    }

    window.location.href = `${env.wpUrl}${route.data['wpPath'] ?? ''}`;
    return false;
};
